//Look into deprecating??

const routeOffsetMinutes = {
  get15DayForecast: 40,
  getAirQualityObservation: 15,
  getAirQualityForecast: 15,
  getCWActiveAlerts: 3,
  getAllActiveAlerts: 3,
  getDetailedMarine7: 10,
  getBuoyConditions: 5,
  getEveryUSGSLocation: 5,
  getTideTable: 60,
  getEarthquakes: 3,
  getHurricanesLive: 3,
  combinedCharts: 120,
  getExtendedFireDanger: 15,
  getDetailedForecastData: 45,
  getAirportConditionsbyState: 10,
  getAirportDelayForecast: 10,
  getHourlyForecast: 60,
};

export default routeOffsetMinutes;
